import React, {useState, useEffect} from 'react'
import {Input, SelectPicker, DatePicker} from 'rsuite';
import {SelectIcon, TickIcon} from '../svg/iconsSvg';


export const NuInsInputNum = ({onChange, placeholder, validationType, slice, value}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    const onchangeHandler = (data) => { 
        let newData = data;

        switch (validationType) {
            case 'noZero':
                newData = newData.replace(/^[0]/, "");
                break;
            default:
                break;
          }

        newData = slice ? newData.replace(/[^0-9]/,"").slice(0,slice) : newData.replace(/[^0-9]/,"")

        setValue(newData )
        if(onChange) onChange(newData);
    }

    return (            
        <div className="nuins_input_field">
             <Input   value={updatedValue}
             placeholder={placeholder}            
             type="text"                   
             onChange={onchangeHandler}
             />
       </div>        
    )
}

export const NuInsInputText = ({onChange, placeholder, validationType, slice, value}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    const onChangeHandler = (data) => {  
        let newData = data;

        switch (validationType) {
            case 'color':
                newData = newData.replace(/[a-zA-Z0-9]/, "");
                break;
            case 'vin':
                newData = newData.replace(/[^0-9a-zA-Z]/, "");
                break;
            case 'plate':
                newData = newData.replace(/^[^a-zA-ZаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]/, "");   
                newData = newData.replace(/[^0-9a-zA-ZаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]/, "");
                break; 
            default:
                //newData = newData;
                break;
          }

        newData = slice ? newData.slice(0, 17) : newData;  
        setValue(newData )
        if(onChange) onChange(newData);
    }

    return(            
        <div className="nuins_input_field">
             <Input  value={updatedValue}
             placeholder={placeholder}            
             type="text"         
             onChange={onChangeHandler} required/>
       </div>        
    )
}

export const NuInsSelect = (props) => {

    const onchangeHandler = (value) => {        
//console.log('select', value)
        if(props.onChange) props.onChange(value);
    }
     // data format supllied to be in the format
    // const options = [{
    //     "label": "Monday",
    //     "value": "Monday",
    //     "role": "Master",
    //   },
    //   {
    //     "label": "Sunday",
    //     "value": "Sunday",
    //     "role": "Master",
    //   }]
      

    return(            
        <div className="nuins_input_field">
             <SelectPicker 
             data={props.options}  //{options}
             placeholder={props.placeholder}
             appearance="subtle"
             searchable={false}
             defaultValue={props.value}
             style={{ display: 'block'}}
             onChange={onchangeHandler}
             />            
       </div>        
    )
}

export const NuInsInputDate = ({placeholder, value, onChange}) => {

    const onchangeHandler = (date) => {        
        if(onChange) onChange(date);
    }

    return(            
        <div className="nuins_input_field">
             <DatePicker 
             appearance="subtle" 
             placeholder={placeholder}
             value={value}
             onChange={onchangeHandler}
             style={{ display: 'block' }}
             />        
       </div>        
    )
}


export const CheckBoxCustom = ({value, onChange}) => {

    const initial = value ? true : false;

    const [visible,setVisible] = useState(initial);

    useEffect(()=> {
        if(value !== visible) setVisible(value)
    }, [value, visible])

    const clickHandler = (e) => {
        e.preventDefault();  
        setVisible(!visible)
       if(onChange) onChange(!visible);
    }

    return(

            <div className="backstyle">
                <div className="checkboxCustom" onClick={ clickHandler}>
                    <SelectIcon />
                    <div className ="checkboxCustomOverlay">
                        {visible ? (<TickIcon />) : null} 
                    </div>
                </div>
            </div>

    )

}

